import { apiClient } from "./api_base";

export const fetchPatientProfiles = async (params = {}) => {
  const response = await apiClient.get('/patient-profiles', { params });
  return response;
};

export const createPatientProfile = async (profileData) => {
  const response = await apiClient.post('/patient-profiles', profileData);
  return response;
};

export const fetchPatientProfileById = async (id) => {
  const response = await apiClient.get(`/patient-profiles/${id}`);
  return response;
};

export const updatePatientProfile = async (id, profileData) => {
  const response = await apiClient.put(`/patient-profiles/${id}`, profileData);
  return response;
};

export const deletePatientProfile = async (id) => {
  const response = await apiClient.delete(`/patient-profiles/${id}`);
  return response;
};

